import { render, staticRenderFns } from "./productSeries.vue?vue&type=template&id=ed7b2cc6&scoped=true&"
import script from "./productSeries.vue?vue&type=script&lang=js&"
export * from "./productSeries.vue?vue&type=script&lang=js&"
import style0 from "./productSeries.vue?vue&type=style&index=0&id=ed7b2cc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7b2cc6",
  null
  
)

export default component.exports